{	"main": {
		"title": "Nalog za let",
		"nazaj": "Nazaj"
	},
	"labels": {
		"datum": "Datum :",
		"pilot":"Izberi pilota :",
		"reg":"Registracija letala :",
		"tip":"Tip letala :",
		"licenca":"Licenca :",
		"ruta":"Ruta :",
		"namen":"Namen :",
		"potnik":"Ime in priimek potnika :"
	},
	"buttons": {
		"posljiOdobritev": "Pošlji nalog v odobritev",
		"dodajPotnika": "Dodaj potnika",
		"brisiIzbiro": "Pobriši izbiro"
	},
	"obvestila": {
		"zapisDodan": "Zapis uspešno dodan.",
		"napakaVnosa": "Napaka pri vnosu podatkov.",
		"napakaInputa": "Nekaterih nujnih podatkov niste izpolnili, preglejte in izpolnite obrazec'",
		"napakaBranja": "Napaka pri branju podatkov.",
		"vprasanjeBrisa": "Ali res želite izbrisati potnika?",
		"napakaPosiljanja": "Napaka pri pošiljanju",
		"uspesnoPoslan": "Uspešno posredovanje naloga za let!"
	}
}